import { useQuery } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { getPostMailingTemplate, listPostMailingTemplates } from '../../api/postMailingTemplatesApi';

import { postMailingTemplatesKeys } from './keys';

export function usePostMailingTemplates() {
	return useQuery({
		queryKey: postMailingTemplatesKeys.list(),
		queryFn: async () => {
			const res = await listPostMailingTemplates();
			return res?.templates ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
	});
}

export function usePostMailingTemplate(id) {
	return useQuery({
		queryKey: postMailingTemplatesKeys.detail(id),
		queryFn: async () => {
			const res = await getPostMailingTemplate(id);
			return res?.template ?? res ?? null;
		},
		enabled: Boolean(id),
		staleTime: STALE_TIMES.STANDARD,
	});
}
